import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Typography from "material-ui-next/Typography";
import Tooltip from "material-ui-next/Tooltip";
import Icon from "material-ui-next/Icon";

import style from "./style";

import { StyledButton, TextField, If, Loadable } from "components/support";

class CompanyIntegrationsTrayView extends Component {
  async openTrayAuthentication(url) {
    const { presenter } = this.props;
    let popupUrl = url;

    await presenter.updateTrayFields();

    if (!/^https?:\/\//.test(popupUrl)) {
      popupUrl = `http://${url}`;
    }

    popupUrl = `${popupUrl}/auth.php?response_type=code&consumer_key=${process.env.REACT_APP_TRAY_CONSUMER_KEY}&callback=${process.env.REACT_APP_TRAY_CALLBACK_URL}`;

    if (popupUrl) {
      const openedPopup = window.open(
        `${popupUrl}`,
        "Autenticação com a Tray",
        "popup"
      );

      const timer = setInterval(() => {
        if (openedPopup.closed) {
          clearInterval(timer);
          presenter.onTrayAuthenticationFinished();
        }
      }, 100);
    }
  }

  render() {
    const { className, presenter, viewModel } = this.props;
    const { tray } = viewModel.company.integrations;
    const { enabled } = tray;
    const { url, store_id } = tray;
    const { loading } = viewModel;
    const disabled = url && store_id ? false : true;

    return (
      <div className={`${className} grid-container`}>
        <Loadable loading={loading}>
          <Row>
            <Col xs={12}>
              <div className="grid-container mt-sm mb-sm">
                <Typography type="headline">Tray</Typography>
                <hr />
                <Row bottom="xs">
                  <Col xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="URL da Loja"
                      value={tray.url}
                      onChange={(_, value) =>
                        presenter.enqueueTrayField("url", value)
                      }
                    />
                  </Col>
                  <Col xs={12} md>
                    <TextField
                      fullWidth
                      label="Número da Loja"
                      value={tray.store_id}
                      onChange={(_, value) =>
                        presenter.enqueueTrayField(
                          "store_id",
                          value.replace(/\D/g, "")
                        )
                      }
                    />
                  </Col>
                  <Col xs={12} md>
                    <StyledButton
                      fullWidth
                      disabled={disabled}
                      style={
                        disabled
                          ? {
                              cursor: "not-allowed",
                              margin: "0px 0px 1.5px 2px"
                            }
                          : { margin: "0px 0px 1.5px 2px" }
                      }
                      label="Autenticar"
                      primary
                      onTouchTap={() =>
                        !disabled && this.openTrayAuthentication(tray.url)
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  <div className="integration-status">
                    <If test={enabled}>
                      <Icon className="done-icon">done</Icon>
                      <span className="icon-span">Integração Ativa</span>
                    </If>
                    <If test={!enabled}>
                      <Icon className="close-icon">close</Icon>
                      <span className="icon-span">Integração Inativa</span>
                    </If>
                    <div className="tooltip">
                      <Tooltip
                        key="tooltip-right-tray"
                        title="A integração só é feita após clicar o botão AUTENTICAR"
                        placement="right"
                      >
                        <Icon className="tooltip-icon">info</Icon>
                      </Tooltip>
                    </div>
                  </div>
                </Row>
              </div>
            </Col>
          </Row>
        </Loadable>
      </div>
    );
  }
}

export default style(CompanyIntegrationsTrayView);



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/integrations/tray/view.jsx